//-------------------------
// calc combat adjustment
//-------------------------
export default function calcCombatAdj({ reverse, current_value, min, max, adj = 1 }) {
  let new_value = 0;

  // adj zero - no change
  if (adj == 0) {
    new_value = current_value;

    // adj <> zero
  } else {
    if (!reverse) {
      new_value = current_value + adj;
      if (new_value < min) {
        new_value = min;
      } else if (new_value > max) {
        new_value = max;
      }

      // reverse adjs
    } else {
      new_value = current_value - adj;
      if (new_value < min) {
        new_value = min;
      } else if (new_value > max) {
        new_value = max;
      }
    }
  }
  return new_value;
}
